import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { WorkflowService } from "./service/workflow.service";
import { WorkflowUtil } from "./workflow.util";
import { Workflow } from "./service/Workflow";
import { S25Util } from "../../util/s25-util";

interface WorkflowProgressDiagramState {
    showDiagram: boolean;
    processInstanceId: number | null;
    diagramProcess: Workflow.ProcessInstance | null;
    /** The submission whose progress is shown; chat from the diagram is scoped to it. */
    submission: Workflow.WorkflowItem | null;
}

export const WorkflowProgressDiagramStore = signalStore(
    { providedIn: "root" },
    withState<WorkflowProgressDiagramState>({
        showDiagram: false,
        processInstanceId: null,
        diagramProcess: null,
        submission: null,
    }),
    withMethods((store) => ({
        async showForInstance(
            processId: number | undefined | null,
            processInstanceId: number | undefined | null,
            submission?: Workflow.WorkflowItem,
        ) {
            if (!processId || !processInstanceId) return;

            if (store.showDiagram() && store.processInstanceId() === processInstanceId) {
                patchState(store, { showDiagram: false });
                return;
            }

            const [process, error] = await S25Util.Maybe(WorkflowService.getWorkflowProcess(processId));
            if (error) {
                S25Util.showError(error);
                return;
            }
            if (!process) return;

            if (!process.stages) process.stages = [];
            if (!process.stageTransitions) process.stageTransitions = [];
            WorkflowUtil.populateStageNamesOnTransitions(process.stageTransitions, process.stages);

            patchState(store, {
                processInstanceId,
                diagramProcess: { ...process, workflowProcessInstanceId: processInstanceId },
                submission: submission ?? null,
                showDiagram: true,
            });
        },
        hide() {
            patchState(store, { showDiagram: false });
        },
    })),
);
